import { LanguagesEnum } from '../../config/languages';

const Configuration = {
  backgroundImage: require('../../assets/images/backgrounds/dark-material-bg.jpg'),
};

export const Translations = {
  recover_title: {
    [LanguagesEnum.English]: 'Recover your password',
    [LanguagesEnum.Greek]: 'Επαναφορά κωδικού',
  },
  form_field_password: {
    [LanguagesEnum.English]: 'Password',
    [LanguagesEnum.Greek]: 'Κωδικός',
  },
  form_field_confirm_password: {
    [LanguagesEnum.English]: 'Confirm password',
    [LanguagesEnum.Greek]: 'Επιβεβαίωση κωδικού',
  },
  form_button_recover: {
    [LanguagesEnum.English]: 'Reset password',
    [LanguagesEnum.Greek]: 'Επαναφορά κωδικού',
  },
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  form_error_match: {
    [LanguagesEnum.English]: 'Confirm password should much password',
    [LanguagesEnum.Greek]:
      'Ο κωδικός επιβεβαίωσης πρέπει να είναι ίδιος με τον κωδικό',
  },
  back_to_login: {
    [LanguagesEnum.English]: 'Back to login',
    [LanguagesEnum.Greek]: 'Επιστροφή στο Login',
  },
};

export default Configuration;
